<template>
  <div>
    <v-card class="info-card">
      <v-card-text>
        <v-container class="pa-0" fluid>
          <v-row>
            <v-col cols="9">
              <h3 class="info-title">{{ title }}</h3>

              <p class="info-description">{{ description }}</p>
            </v-col>
            <v-col cols="3">
              <p class="status">
                <mf-icon fill small :color="statusColor">fiber_manual_record</mf-icon><span>{{ formatedStatus }}</span>
              </p>
            </v-col>
          </v-row>
        </v-container>

        <v-container class="pa-0" fluid>
          <v-row>
            <v-col cols="4">
              <h3 class="info-date">Data e hora de envio</h3>
              <p class="info-description">{{ DateTime.fromFormat(date, 'yyyy-MM-dd').toFormat('dd/MM/yyyy') }} - {{ time }}</p>
              <p v-if="canceled" class="cancel">
                disparos cancelados às {{ DateTime.fromISO(canceledAt).toFormat('HH:mm') }}
                <br />
                por {{ canceledBy }}
              </p>
            </v-col>
            <v-col v-if="initialDate && finalDate" cols="4">
              <h3 class="info-time">Periodo de mensuração</h3>
              <p class="info-description">
                {{ DateTime.fromFormat(initialDate, 'yyyy-MM-dd').toFormat('dd/MM/yyyy') }} -
                {{ DateTime.fromFormat(finalDate, 'yyyy-MM-dd').toFormat('dd/MM/yyyy') }}
              </p>
            </v-col>
            <v-col cols="4">
              <h3 class="info-time mb-0">Disparadores</h3>
              <div v-if="senders">
                <v-chip-group show-arrows active-class="primary--text" class="py-0">
                  <v-chip v-for="(sender, index) in senders" :key="index" small :ripple="false">
                    <span>{{ `${getSenderName(sender.name)} ${formatNumber(sender.number)}` }}</span>
                  </v-chip>
                </v-chip-group>
              </div>
              <p v-else class="info-description">Sem disparadores selecionados</p>
            </v-col>
          </v-row>
        </v-container>

        <v-container class="pa-0" fluid>
          <v-row>
            <v-col cols="4">
              <h3 class="info-segments">Público alvo</h3>
              <v-chip-group v-if="targetingMode === 'SEGMENTED' && segments && segments.length" show-arrows active-class="primary--text">
                <v-chip v-for="(segment, index) in segments" :key="index" small :ripple="false">
                  <span v-if="segment"
                    ><b>{{ segment.name }}</b
                    >{{ segment.clients_qty_at_campaign !== null ? ` (${localeString(segment.clients_qty_at_campaign)} clientes)` : '' }}</span
                  >
                </v-chip>
              </v-chip-group>
              <p v-else class="info-description">{{ targetingModeDescription }}</p>
            </v-col>
            <v-col v-if="products && products.length" cols="8">
              <h3 class="info-products mb-0">Produtos</h3>
              <v-chip-group show-arrows active-class="primary--text">
                <v-chip v-for="(product, index) in products" :key="index" small :ripple="false">
                  <span>{{ product.sku }} - {{ product.name }}</span>
                </v-chip>
              </v-chip-group>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { phoneNumberFormat } from '@/helpers/phoneNumberFormat.js'
import { DateTime } from 'luxon'
import { localeString } from '@/config/helpers.js'

export default {
  props: {
    title: String,
    description: String,
    date: String,
    time: String,
    segments: Array,
    products: Array,
    initialDate: String,
    finalDate: String,
    senders: Array,
    targetingMode: String,
    status: String,
    canceled: Boolean,
    canceledAt: String,
    canceledBy: String,
  },
  data: () => ({
    DateTime: DateTime,
  }),
  computed: {
    targetingModeDescription() {
      switch (this.targetingMode) {
        case 'ALL':
        case 'SEGMENTED':
          return 'Todos os contatos'
        case 'LOYALTY':
          return 'Contatos do clube'
        case 'NON_LOYALTY':
          return 'Contatos fora do clube'
      }
      return ''
    },

    statusColor() {
      if (this.status === 'FINISHED') {
        return '#2b67e5'
      }

      if (this.status === 'ACTIVE') {
        return '#77E56D'
      }

      return '#BFBFBF'
    },

    formatedStatus() {
      switch (this.status) {
        case 'FINISHED':
          return 'CONCLUÍDA'
        case 'ACTIVE':
          return 'ATIVA'
        default:
          return this.status
      }
    },
  },
  methods: {
    localeString,
    formatNumber(number) {
      return phoneNumberFormat(number)
    },
    getSenderName(value) {
      return value ? `${value} - ` : ``
    },
  },
}
</script>

<style lang="scss">
.status {
  padding-bottom: 4px;
  span {
    font-size: 12px;
    letter-spacing: 0.2px;
    color: $marca-0-l40;
  }
}
.info-card {
  .info-title {
    font-size: 20px;
    font-weight: bold;
    letter-spacing: 0.33px;
    margin-bottom: 8px;
    color: $cinza-d20;
  }
  .info-description {
    font-size: 14px;
    letter-spacing: 0.23px;
    color: $cinza-d10;
    margin-bottom: 0;
  }
  .info-date,
  .info-time,
  .info-segments,
  .info-products {
    font-size: 18px;
    letter-spacing: 0.33px;
    margin-bottom: 8px;
    color: $cinza-d20;
  }

  .date-box,
  .time-box {
    width: fit-content;
    padding: 2px 12px;
    border-radius: 16px;
    background-color: $cinza-l70;
    font-size: 14px;
    letter-spacing: 0.23px;
    text-align: center;
    color: $cinza-d20;
  }

  .cancel {
    text-transform: uppercase;
    color: red;
  }
}
</style>
